import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  div.save-wrapper {
    padding-bottom: 16px;
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    div.password-right {
      div:nth-child(3) {
        & > div.txt-inp {
          margin-bottom: 24px;
        }
      }
    }
  }
`;
